import { call, fork, join, select } from 'redux-saga/effects';
import { Task } from 'redux-saga';
import { bulkFilesClosedSaga } from 'features/content-library/sagas/bulkFilesClosedSaga';
import { signalingBulkContentClosed } from 'features/layout/features/content/actions';
import { selectGridPanel } from 'features/layout/features/content/contentSlice';
import { ContentRef, GridPanelName } from 'features/layout/features/content/types';
import { bulkScreensharesClosedSaga } from 'features/screenshare/sagas/bulkScreensharesClosedSaga';
import { openLastActiveContentSaga } from 'features/layout/features/content/sagas/openLastActiveContentSaga';
import { bulkWhiteboardsClosedSaga } from 'features/layout/sagas/bulkWhiteboardsClosedSaga';

const collectIdsByType = (content: ContentRef[], type: ContentRef['type']) =>
  content.filter((item) => item.type === type).map((item) => item.id);

export function* onBulkContentClosedSaga(action: ReturnType<typeof signalingBulkContentClosed>) {
  const { content } = action.payload;

  const whiteboardIds = collectIdsByType(content, 'whiteboard');
  const fileIds = collectIdsByType(content, 'file');
  const screenshareIds = collectIdsByType(content, 'screenshare');

  const tasks: Task[] = [];

  if (whiteboardIds.length > 0) {
    tasks.push(yield fork(bulkWhiteboardsClosedSaga, whiteboardIds));
  }

  if (fileIds.length > 0) {
    tasks.push(yield fork(bulkFilesClosedSaga, fileIds));
  }

  if (screenshareIds.length > 0) {
    tasks.push(yield fork(bulkScreensharesClosedSaga, screenshareIds));
  }

  if (tasks.length > 0) {
    yield join(tasks);
  }

  const currentPanel: GridPanelName = yield select(selectGridPanel);

  if (!currentPanel) {
    return;
  }

  yield call(openLastActiveContentSaga);
}
